
import { io } from "socket.io-client";
import { base_url } from "../Utils/baseUrl";

const SOCKET_URL =
    process.env.REACT_APP_SOCKET_URL || new URL(base_url).origin;

let socket = null;

export function connectSocket(token) {
    if (!token) {
        console.error("[Socket] Cannot connect: token is missing");
        return null;
    }

    if (socket) {
        socket.auth = { token };

        if (!socket.connected) {
            socket.connect();
        }

        return socket;
    }

    socket = io(SOCKET_URL, {
        auth: { token },
        transports: ["polling"],
        reconnection: true,
        reconnectionAttempts: Infinity,
    });

    socket.on("connect", () => {
        console.log("[Socket] Connected successfully");
    });

    socket.on("connect_error", (error) => {
        console.error("[Socket] Connection failed:", error.message);
        console.error("[Socket] Error details:", {
            description: error.description,
            context: error.context,
        });
    });

    socket.on("disconnect", (reason) => {
        console.warn("[Socket] Disconnected:", reason);
    });

    socket.io.on("reconnect_attempt", (attempt) => {
        console.log("[Socket] Reconnection attempt:", attempt);
    });

    socket.io.on("reconnect", () => {
        console.log("[Socket] Reconnected successfully");
    });

    return socket;
}

export function disconnectSocket() {
    if (socket) {
        console.log("[Socket] Disconnecting...");
        socket.removeAllListeners();
        socket.disconnect();
        socket = null;
    }
}
